var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmPond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 49,
    viewBox: "0 0 44 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0118 21.1612C43.0118 27.5673 41.416 31.8757 35.1481 37.6328C35.0308 37.7423 21.838 48.968 21.838 48.968C21.838 48.968 8.58982 37.552 8.47247 37.4425C3.67948 33.2279 0.671875 27.5673 0.671875 21.1612C0.671875 9.46747 10.152 -0.00488281 21.838 -0.00488281C33.5317 -0.00488281 43.0118 9.46747 43.0118 21.1612Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9186 38.535C31.6012 38.535 39.4505 30.6857 39.4505 21.0031C39.4505 11.3205 31.6012 3.47119 21.9186 3.47119C12.236 3.47119 4.38672 11.3205 4.38672 21.0031C4.38672 30.6857 12.236 38.535 21.9186 38.535Z",
    fill: "#FFB510",
    stroke: "#FFAA00",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0972 15.1452C15.0754 15.1452 15.8683 14.3522 15.8683 13.3741C15.8683 12.396 15.0754 11.603 14.0972 11.603C13.1191 11.603 12.3262 12.396 12.3262 13.3741C12.3262 14.3522 13.1191 15.1452 14.0972 15.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6676 15.1452C22.6457 15.1452 23.4386 14.3522 23.4386 13.3741C23.4386 12.396 22.6457 11.603 21.6676 11.603C20.6894 11.603 19.8965 12.396 19.8965 13.3741C19.8965 14.3522 20.6894 15.1452 21.6676 15.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2379 15.1452C30.216 15.1452 31.0089 14.3522 31.0089 13.3741C31.0089 12.396 30.216 11.603 29.2379 11.603C28.2597 11.603 27.4668 12.396 27.4668 13.3741C27.4668 14.3522 28.2597 15.1452 29.2379 15.1452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0972 22.5397C15.0754 22.5397 15.8683 21.7468 15.8683 20.7686C15.8683 19.7905 15.0754 18.9976 14.0972 18.9976C13.1191 18.9976 12.3262 19.7905 12.3262 20.7686C12.3262 21.7468 13.1191 22.5397 14.0972 22.5397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6676 22.5397C22.6457 22.5397 23.4386 21.7468 23.4386 20.7686C23.4386 19.7905 22.6457 18.9976 21.6676 18.9976C20.6894 18.9976 19.8965 19.7905 19.8965 20.7686C19.8965 21.7468 20.6894 22.5397 21.6676 22.5397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2379 22.5397C30.216 22.5397 31.0089 21.7468 31.0089 20.7686C31.0089 19.7905 30.216 18.9976 29.2379 18.9976C28.2597 18.9976 27.4668 19.7905 27.4668 20.7686C27.4668 21.7468 28.2597 22.5397 29.2379 22.5397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0972 29.9342C15.0754 29.9342 15.8683 29.1413 15.8683 28.1632C15.8683 27.185 15.0754 26.3921 14.0972 26.3921C13.1191 26.3921 12.3262 27.185 12.3262 28.1632C12.3262 29.1413 13.1191 29.9342 14.0972 29.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6676 29.9342C22.6457 29.9342 23.4386 29.1413 23.4386 28.1632C23.4386 27.185 22.6457 26.3921 21.6676 26.3921C20.6894 26.3921 19.8965 27.185 19.8965 28.1632C19.8965 29.1413 20.6894 29.9342 21.6676 29.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2379 29.9342C30.216 29.9342 31.0089 29.1413 31.0089 28.1632C31.0089 27.185 30.216 26.3921 29.2379 26.3921C28.2597 26.3921 27.4668 27.185 27.4668 28.1632C27.4668 29.1413 28.2597 29.9342 29.2379 29.9342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.671875 -0.00488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmPond);
export default __webpack_public_path__ + "static/media/farm-pond.00d973d7dbfdecad1afe8040de1592c5.svg";
export { ForwardRef as ReactComponent };